// extracted by mini-css-extract-plugin
export default {"menuContainer":"UserDartment_menuContainer__FixJR","menu":"UserDartment_menu__YB-mc"};